import React, { useState, useEffect, useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO, format } from 'date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import DetailTable from './DetailTable';
import { useTranslation } from "react-i18next";
import PrintIcon from '@material-ui/icons/Print';
// import PayRollPrint from '../../components/PayRoll/PayRollPrint';
import PermissionContext from '../../contexts/PermissionContext';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(18),
        maxWidth: 950,
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    button: {
        margin: theme.spacing(1, 0, 1),
    },
    textField: {
        height: "100px"
    }
}));


const endpoint = `payroll`;
const prTypeEndpoint = `pr-type`
const DATE_FORMAT = 'yyyy-MM-dd';

const PayRollForm = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { idToUpdate, configData, permission } = props;

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')


    const [payrollId, setPayRollId] = useState(props.idToUpdate)
    useEffect(() => {
        let isActive = true;
        return () => { isActive = false };
    }, [payrollId, setPayRollId]);

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedPaymentDate, setSelectedPaymentDate] = useState(new Date());

    // Getting PrType data only once at the beggining
    const [prTypeData, setPrTypeData] = useState([]);
    useEffect(() => {

        retrievePrTypeData()
    }, []); // Those ARE connectec

    const retrievePrTypeData = () => {
        DataService.getAll(prTypeEndpoint)
            .then(response => {
                setPrTypeData(response.data)
                // console.log(response.data);
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }


    const [notesValue, setNotesValue] = useState("")
    const [messageValue, setMessageValue] = useState("")
    const [payrollData, setpayrollData] = useState({})

    //prType combobox values
    const [prTypeValue, setPrTypeValue] = React.useState(prTypeData[0]);
    const [prTypeInputValue, setPrTypeInputValue] = React.useState('');


    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************


    const [data, setData] = useState([]);
    useEffect(() => {
        let id = typeof idToUpdate === 'object' ? 0 : idToUpdate
        getData(id)
    }, []);

    const getData = (id) => {
        DataService.get(id, endpoint)
            .then(response => {
                // console.log("get data", response.data)
                setPayRollId(response.data.id)
                setSelectedDate(parseISO(response.data.date))
                setSelectedPaymentDate(parseISO(response.data.payment_date))
                setPrTypeInputValue(response.data.pr_type.name)
                setPrTypeValue(response.data.pr_type)
                setNotesValue(response.data.notes)
                setMessageValue(response.data.message)
                setpayrollData(response.data)
            })
            .catch(e => {
                console.log(e)
                if (e.response.status !== 404) {
                    openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
                } else {
                    // setData({})
                    console.log("Unexpected error: ", e)
                }

            });
    }

    const updateData = (values) => {
        DataService.update(endpoint, values)
            .then(response => {
                // console.log("update", response)
                openNoticeBox("Notice", t("record_updated_successfully", { "table": t("payroll_table_title") }))
                getData(response.data.id)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    const addData = (values) => {
        DataService.create(`${endpoint}`, values)
            .then(response => {
                openNoticeBox("Notice", t("record_created_successfully", { "table": t("payroll_form_payroll_id") }))
                setPayRollId(response.data.id)
                getData(response.data.id)
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText}`)
            });
    }

    const prePrintPayRoll = (payrollData, configData) => {
        // console.log("pre", payrollData)
        // setData(payrollData.id)
        // PayRollPrint(payrollData, configData)
    }


    const submitForm = (event) => {
        event.preventDefault();
        var newDate, newPaymentDate = ""
        newDate = format(selectedDate, DATE_FORMAT)
        newPaymentDate = format(selectedPaymentDate, DATE_FORMAT)
        if (typeof prTypeValue === 'undefined') {
            openNoticeBox("Notice", t("fill_all_fields_msg", { "table": t("payroll_table_title") }))
            return false
        }
        let values = {
            'pr_type_id': prTypeValue.id,
            'date': newDate,
            'payment_date': newPaymentDate,
            'notes': notesValue,
            'message': messageValue
        }
        console.log("values", values)

        if (payrollId === 0) {
            addData(values)
        }
        if (payrollId > 0) {
            values.id = payrollId

            updateData(values)
        }
        // console.log("submit ",values)

    }

    const handleReset = (event) => {

    }

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <CssBaseline />
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />

            <form className={classes.form} onSubmit={submitForm} onReset={handleReset}>
                <Grid container spacing={1}>
                    <Grid item xs={3}>
                        <Typography variant="h4" component="h4">
                            {t("payroll_form_payroll_id")}: {payrollId ? payrollId : 0}
                        </Typography>
                        <Autocomplete
                            id="pr_type"
                            // value={value}
                            options={prTypeData}
                            getOptionLabel={(option) => option.name ? option.name : "-"}
                            onChange={(event, newValue) => {
                                setPrTypeValue(newValue);
                            }}
                            inputValue={prTypeInputValue}
                            onInputChange={(event, newInputValue) => {
                                setPrTypeInputValue(newInputValue);
                            }}

                            value={prTypeValue ? prTypeValue : ""}
                            renderInput={(params) => <TextField {...params} label={t("payroll_form_lbl_payroll_pr_type")} variant="outlined" />}
                            getOptionSelected={(option, value) => option.value === value.value}
                        />
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                clearable="true"
                                value={selectedDate}
                                placeholder="2021-07-07"
                                onChange={date => setSelectedDate(date)}
                                // minDate={new Date()}
                                format={DATE_FORMAT}
                                autoOk
                                name="date"
                                id="date"
                                variant="inline"
                                inputVariant="outlined"
                                style={{ marginTop: '5px' }}
                            />
                            <KeyboardDatePicker
                                clearable="true"
                                value={selectedPaymentDate}
                                placeholder="2021-07-07"
                                onChange={paymentDate => setSelectedPaymentDate(paymentDate)}
                                // minDate={new Date()}
                                format={DATE_FORMAT}
                                autoOk
                                name="payment_date"
                                id="payment_date"
                                variant="inline"
                                inputVariant="outlined"
                                style={{ marginTop: '5px' }}
                            />
                        </MuiPickersUtilsProvider>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="notes"
                            label={t("payroll_form_lbl_payroll_notes")}
                            name="notes"
                            multiline
                            rows={4}
                            onChange={event => setNotesValue(event.target.value)}
                            value={notesValue}
                            style={{ marginTop: '5px' }}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="message"
                            label={t("payroll_form_lbl_payroll_message")}
                            name="message"
                            multiline
                            rows={4}
                            className={classes.textField}
                            onChange={event => setMessageValue(event.target.value)}
                            value={messageValue}
                            style={{ marginTop: '-2px' }}
                        />
                        <Grid container spacing={0}>
                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    disabled={payrollId === 0 ? false : !hasAddPerm ? true : !hasEditPerm ? true : false}
                                >
                                    {payrollId === 0 ? t("save_form_button") : t("update_form_button")}
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant="contained"
                                    color="default"

                                    fullWidth
                                    className={classes.Button}
                                    startIcon={<PrintIcon />}
                                    // onClick = {() => PayRollPrint(payrollData, configData) }
                                    onClick={() => prePrintPayRoll(payrollData, configData)}
                                    // onClick = {() => console.log(payrollData, configData) }
                                    disabled={payrollId === 0 ? true : false}
                                >
                                    {t("print_form_button")}

                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={9}>
                        <DetailTable
                            payrollId={payrollId}
                            setPayRollId={setPayRollId}
                            // dctValue={dctValue}
                            // taxValue={taxValue}
                            // productData={productData}
                            // setProductData={setProductData}
                            // prTypeData={prTypeData}
                            // setPrTypeData={setPrTypeData}
                            getPayRollData={getData}
                            permission={permission}
                        />
                    </Grid>

                </Grid>
            </form>
            <Box mt={8}>

            </Box>

        </Paper>
    )
})

export default PayRollForm;
    // ReactDOM.render(<WithMaterialUI />, document.getElementById('root'));
